export const PAGE_LOGIN = 'pg_login';
export const PAGE_HOME = 'pg_home';
export const NOT_FOUND = 'pg_notFound';
export const ORDERS = 'pg_orders';
export const PAGE_APPLICATIONS = 'pg_applications';
